module.exports = __webpack_public_path__ + "assets/d9b8906fcf737d05c9bbbc727b3cd41e.mp3";